(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // Move Oystex Icon to top of feature list
  if (document.getElementById('oystex-feature')) {
    let featureList = document.querySelector('.product-features');
    let features= document.querySelectorAll('.product-features__feature');
    features.forEach(function(feature) {
      if( feature.childNodes[0].id == 'oystex-feature' ) {
        const oystexFeature = feature;
        feature.remove();
        featureList.prepend(oystexFeature);
      }
    })

    let featureArray = Array.from(features);

    let oystexIndex = featureArray.findIndex(checkOyster);

    function checkOyster(feature) {
      return feature.childNodes[0].id == 'oystex-feature'
    }

    const oystex = featureArray[oystexIndex];

    featureArray.splice(oystexIndex, 1);
    featureArray.unshift(oystex);
  }

  // Control Product Thumbs
  // need to make this work for videos, check media type and render video element instead of img
  const productThumbs = document.querySelectorAll('.desktop-product__thumb');
  const mediaWrapper = document.querySelector('.desktop-product-images');
  var productFeature = document.querySelector('.desktop-product-feature img');
  const productFeatureContainer = document.querySelector('.desktop-product-feature');

  productThumbs.forEach(function(thumb, index) {
    // add active class to default image
    if(index == 0 ) {
      thumb.classList.add('active');
    }
    // event listener to change image
    thumb.addEventListener('click', function() {
      // remove active from other images
      productThumbs.forEach(function(oldThumb) {
        oldThumb.classList.remove('active');
      });
      // add active and swap the src and srcset
      thumb.classList.add('active');
      if ( thumb.dataset.media != 'video' ) {
        productFeatureContainer.style.display = 'block';
        //if there is a video, remove it
        if ( mediaWrapper.querySelector('.video-active') ) {
          const videoToBeRemoved = mediaWrapper.querySelector('.desktop-product__media');
          mediaWrapper.removeChild(mediaWrapper.lastChild);
        }
        productFeature.srcset = thumb.dataset.media + ' 1x';
        productFeature.src = thumb.dataset.media;
      } else {
        if ( !mediaWrapper.querySelector('.video-active')) {
          const videoObject = thumb.querySelector('.desktop-product__media').cloneNode(true);
          videoObject.classList.add('video-active');
          productFeatureContainer.style.display = 'none';
          mediaWrapper.appendChild(videoObject);
        }
      }
    })
  });

  // Size Guide Controls
  const sizeGuide = document.querySelector('.size-guide-popup');
  if ( sizeGuide != undefined ) {
    const sizeGuideClose = document.querySelector('.size-guide_close');
    const sizeGuideOpen = document.querySelector('.size-guide_open');
    const sizeGuideInner = document.querySelector('.size-guide_inner');

    sizeGuideOpen.addEventListener('click', function() {
      sizeGuide.classList.add('open');
    })
    sizeGuideClose.addEventListener('click', function() {
      sizeGuide.classList.remove('open');
    })
    sizeGuide.addEventListener('click', function() {
      sizeGuide.classList.remove('open');
    })
    sizeGuideInner.addEventListener('click', function(e) {
      e.stopPropagation();
    })
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
